import './aggregatorAcceptConsentStepKO.scss';

// @vendors
import React from 'react';
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');

// @components
import { OKButton } from 'commonsComponents/OKButton';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
const { formatText } = require('core/i18n').i18n;

// @constants
import Storage from 'utilities/storage';
import { PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';
import { RENEW_CONSENT, CREATE_CONSENT, } from 'constants/aggregator/psd2DecoupledFlowType';

const {
    recordPath,
    recordLink,
    PROC_AGGREGATOR,
    PROC_AGGREGATOR_CONSENT,
    PROC_AGGREGATOR_CONSENT_ERROR,
    PROC_AGGREGATOR_CONSENT_RETRY,
    PROC_AGGREGATOR_RENEW_CONSENT,
    PROC_AGGREGATOR_RENEW_CONSENT_ERROR,
    PROC_AGGREGATOR_RENEW_CONSENT_RETRY,
    PROC_FAIL,
} = require('utilities/tagging');

class AggregatorAcceptConsentStepKO extends React.Component {

    constructor(props) {
        super(props);
        const psd2FlowType = Storage.localStorage.get(PSD2_FLOW_TYPE) || '';
        this.state = { psd2FlowType };
    }

    componentDidMount() {
        const { psd2FlowType } = this.state;

        if (psd2FlowType === CREATE_CONSENT) {
            recordPath(PROC_AGGREGATOR_CONSENT_ERROR, null, PROC_AGGREGATOR_CONSENT, PROC_FAIL);
        } else if (psd2FlowType === RENEW_CONSENT) {
            recordPath(PROC_AGGREGATOR_RENEW_CONSENT_ERROR, null, PROC_AGGREGATOR_RENEW_CONSENT, PROC_FAIL);
        }
    }

    handleGoToLink = (link) => {
        const { psd2FlowType } = this.state;

        if (psd2FlowType === CREATE_CONSENT) {
            recordLink(PROC_AGGREGATOR, PROC_AGGREGATOR_CONSENT_RETRY);
        } else if (psd2FlowType === RENEW_CONSENT) {
            recordLink(PROC_AGGREGATOR, PROC_AGGREGATOR_RENEW_CONSENT_RETRY);
        }
        this.props.history.push(link);
    }

    render() {
        const { psd2FlowType } = this.state;

        const isCreateFlow = psd2FlowType === CREATE_CONSENT;
        const titleText = isCreateFlow ? 'aggregatorPSD2-consentKoTitle' : 'aggregatorPSD2-renewConsentKoTitle';
        const mainText = isCreateFlow ? 'aggregatorPSD2-consentKoMainText' : 'aggregatorPSD2-renewConsentKoMainText';

        return (
            <OKSectionBox className="col-md-8 aggregator-accept-consent-ko" title={formatText(titleText)} icon="error" titleSeparator >
                <div className="aggregator-accept-consent-ko__content">
                    <p>{formatText(mainText)}</p>
                    <div className="aggregator-accept-consent-ko__buttons">
                        <OKButton modifier="ghost" onClick={()=> this.handleGoToLink("/myprofile/global/entities/consent/step")}>{formatText('aggregatorPSD2-consentKoTryAgainButton')}</OKButton>
                        <OKButton modifier="link-complementary"  onClick={()=> this.props.history.push("/myprofile/global")}>{formatText('aggregatorPSD2-consentKoGPButton')}</OKButton>
                    </div>
                </div>
            </OKSectionBox>
        );
    }
}

AggregatorAcceptConsentStepKO.propTypes = {
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorAcceptConsentStepKO);
